module.exports = function(data) {
var __t, __p = '';
__p += '<div class="category-item-action">\n    <span class="category-item-action exclude" data-toggle="tooltip" data-placement="top" title="' +
((__t = ( strings.excludeFilter )) == null ? '' : __t) +
'"><i class="far fa-minus icon" aria-hidden="true"></i></span>\n    <span class="category-item-action include" data-toggle="tooltip" data-placement="top" title="' +
((__t = ( strings.includeFilter )) == null ? '' : __t) +
'"><i class="far fa-plus icon" aria-hidden="true"></i></span>\n    <span class="suggestion">' +
((__t = ( data.name )) == null ? '' : __t) +
'</span>\n</div>';
return __p
}